var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDraftIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 59,
    height: 57,
    viewBox: "0 0 59 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.921 48.451C36.2091 49.6107 34.0553 50.5771 31.4321 51.4331L27.0693 52.869C16.107 56.4034 10.336 53.4488 6.77403 42.4867L3.23963 31.5798C-0.294768 20.6176 2.63215 14.819 13.5943 11.2846L17.9571 9.84875C19.0892 9.48979 20.1661 9.18605 21.1877 8.99277C20.3594 10.6771 19.6967 12.7205 19.1444 15.0675L16.4384 26.6371C13.7324 38.1791 17.2944 43.8673 28.8089 46.6009L33.4478 47.7054C35.0494 48.092 36.5404 48.3405 37.921 48.451Z",
    fill: "#6B8F74",
    stroke: "white",
    strokeWidth: 3.64,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.2393 18.463L44.6313 21.8593",
    stroke: "white",
    strokeWidth: 3.64,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28.5342 29.152L36.5418 31.1954",
    stroke: "white",
    strokeWidth: 3.64,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M54.213 8.99523C57.1951 12.3087 57.7198 17.0581 56.1458 23.7403L53.4398 35.2823C51.1204 45.2504 46.5367 49.2818 37.9216 48.4535C36.541 48.343 35.0499 48.0945 33.4484 47.7079L28.8095 46.6034C17.295 43.8698 13.733 38.1816 16.439 26.6396L19.1451 15.07C19.6973 12.7229 20.36 10.6796 21.1884 8.99523C24.4191 2.31301 29.914 0.518198 39.1366 2.69958L43.7478 3.77647",
    stroke: "white",
    strokeWidth: 3.64,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDraftIcon);
export default __webpack_public_path__ + "static/media/draftIcon.d10bc618a72206f957c8812611b3b2e9.svg";
export { ForwardRef as ReactComponent };